import React from 'react';

const IndustriesWeServe: React.FC = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container px-lg-5">
        <div className="section-title position-relative text-center mx-auto mb-5 pb-4 wow fadeInUp"
          data-wow-delay="0.1s" style={{ maxWidth: "800px" }}>
          <h1 className="display-4 mb-4">Industries We Serve</h1>
          <p className="mb-1">We deliver tailored water and wastewater treatment solutions across diverse industries —
            from heavy manufacturing and processing plants to municipal and commercial sectors — ensuring
            efficiency, sustainability, and regulatory compliance.</p>
        </div>
        <div className="row gy-5 gx-4 industries-we-serve">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
            <div className="position-relative shadow rounded border-top border-5 border-primary">
              <div className="d-flex align-items-center justify-content-center position-absolute top-0 start-50 translate-middle bg-primary rounded-circle"
                style={{ width: "45px", height: "45px", marginTop: "-3px" }}>
                <i className="fa fa-share-alt text-white"></i>
              </div>
              <div className="text-center border-bottom p-4 pt-5 h-200">
                <h4 className="fw-bold">Heavy Industries</h4>
                <p className="mb-0">Customized water treatment solutions for cement, power, mining, chemical,
                  and oil & gas industries.</p>
              </div>
              <div className="text-center border-bottom p-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"
                  fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                  stroke-linecap="round">
                  <rect x="6" y="28" width="52" height="30" fill="#ff5512" stroke="#555" />
                  <polygon points="6,28 18,12 30,28" fill="#bdbdbd" stroke="#555" />
                  <rect x="36" y="8" width="6" height="20" fill="#ff5512" stroke="#555" />
                  <rect x="48" y="12" width="6" height="16" fill="#ff5512" stroke="#555" />
                  <rect x="12" y="38" width="8" height="10" fill="#e0e0e0" stroke="#555" />
                  <rect x="24" y="38" width="8" height="10" fill="#e0e0e0" stroke="#555" />
                  <rect x="36" y="38" width="8" height="10" fill="#e0e0e0" stroke="#555" />
                </svg>
              </div>
              <div className="p-2">
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <rect x="14" y="18" width="36" height="28" fill="#ff5512" stroke="#555" />
                    <polygon points="14,18 32,6 50,18" fill="#bdbdbd" stroke="#555" />
                    <rect x="24" y="28" width="16" height="16" fill="#e0e0e0" stroke="#555" />
                  </svg>
                  Cement
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <polygon points="28,6 18,34 32,34 22,58 42,26 28,26 38,6" fill="#ff5512"
                      stroke="#555" />
                  </svg>
                  Power Generation
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <line x1="12" y1="52" x2="36" y2="28" stroke="#555" stroke-width="3" />
                    <rect x="16" y="20" width="24" height="6" fill="#ff5512" stroke="#555" />
                    <line x1="40" y1="16" x2="44" y2="20" stroke="#555" stroke-width="3" />
                  </svg>
                  Mining & Metallurgy
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <path d="M22 12 L42 12 L34 52 L30 52 L22 12 Z" fill="#ff5512" stroke="#555" />
                    <circle cx="32" cy="38" r="6" fill="#e0e0e0" stroke="#555" />
                  </svg>
                  Chemical Manufacturing
                </p>
                <p className="mb-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <path d="M32 8 C20 24, 20 44, 32 56 C44 44, 44 24, 32 8 Z" fill="#ff5512"
                      stroke="#555" />
                    <path d="M26 30 C28 26, 36 26, 34 34 C38 30, 26 38, 26 30 Z" fill="#bdbdbd"
                      stroke="#555" />
                  </svg>
                  Oil & Gas
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
            <div className="position-relative shadow rounded border-top border-5 border-secondary">
              <div className="d-flex align-items-center justify-content-center position-absolute top-0 start-50 translate-middle bg-secondary rounded-circle"
                style={{ width: "45px", height: "45px", marginTop: "-3px" }}>
                <i className="fa fa-server text-white"></i>
              </div>
              <div className="text-center border-bottom p-4 pt-5 h-200">
                <h4 className="fw-bold">Manufacturing & Processing</h4>
                <p className="mb-0">Efficient water treatment solutions tailored for textile, automotive, food,
                  beverage, and pulp industries.</p>
              </div>
              <div className="text-center border-bottom p-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"
                  fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                  stroke-linecap="round">
                  <circle cx="16" cy="48" r="12" fill="#ff5512" stroke="#555" />
                  <g stroke="#555" stroke-width="2" stroke-linecap="round">
                    <line x1="16" y1="32" x2="16" y2="24" />
                    <line x1="16" y1="64" x2="16" y2="56" />
                    <line x1="4" y1="48" x2="12" y2="48" />
                    <line x1="20" y1="48" x2="28" y2="48" />
                    <line x1="9" y1="37" x2="13" y2="43" />
                    <line x1="19" y1="53" x2="23" y2="59" />
                    <line x1="9" y1="59" x2="13" y2="53" />
                    <line x1="19" y1="43" x2="23" y2="37" />
                  </g>
                  <rect x="36" y="28" width="22" height="30" fill="#ff5512" stroke="#555" />
                  <polygon points="36,28 47,16 58,28" fill="#bdbdbd" stroke="#555" />
                  <rect x="52" y="12" width="6" height="16" fill="#ff5512" stroke="#555" />
                  <rect x="40" y="38" width="6" height="10" fill="#e0e0e0" stroke="#555" />
                  <rect x="50" y="38" width="6" height="10" fill="#e0e0e0" stroke="#555" />
                </svg>
              </div>
              <div className="p-2">
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                    viewBox="0 0 64 64" fill="none" stroke="#555" stroke-width="2"
                    stroke-linejoin="round" stroke-linecap="round">
                    <rect x="24" y="14" width="16" height="36" fill="#ff5512" stroke="#555" />
                    <line x1="24" y1="18" x2="40" y2="18" stroke="#555" stroke-width="2" />
                    <line x1="24" y1="30" x2="40" y2="30" stroke="#555" stroke-width="2" />
                    <line x1="24" y1="42" x2="40" y2="42" stroke="#555" stroke-width="2" />
                  </svg>
                  Textile
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                    viewBox="0 0 64 64" fill="none" stroke="#555" stroke-width="2"
                    stroke-linejoin="round" stroke-linecap="round">
                    <rect x="12" y="28" width="40" height="18" fill="#ff5512" stroke="#555" rx="6"
                      ry="6" />
                    <circle cx="20" cy="48" r="6" fill="#bdbdbd" stroke="#555" />
                    <circle cx="44" cy="48" r="6" fill="#bdbdbd" stroke="#555" />
                    <line x1="18" y1="28" x2="18" y2="20" stroke="#555" stroke-width="2" />
                    <line x1="46" y1="28" x2="46" y2="20" stroke="#555" stroke-width="2" />
                  </svg>
                  Automobile
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <line x1="20" y1="14" x2="20" y2="46" stroke="#555" stroke-width="3" />
                    <line x1="24" y1="14" x2="24" y2="46" stroke="#555" stroke-width="3" />
                    <rect x="32" y="14" width="14" height="30" fill="#ff5512" stroke="#555" />
                    <path d="M32 14 Q39 8, 46 14" fill="#bdbdbd" stroke="#555" />
                  </svg>
                  Food & Beverage
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                    viewBox="0 0 64 64" fill="none" stroke="#555" stroke-width="2"
                    stroke-linejoin="round" stroke-linecap="round">
                    <rect x="18" y="14" width="28" height="36" fill="#ff5512" stroke="#555" rx="4"
                      ry="4" />
                    <line x1="24" y1="22" x2="42" y2="22" stroke="#555" stroke-width="2" />
                    <line x1="24" y1="30" x2="42" y2="30" stroke="#555" stroke-width="2" />
                    <line x1="24" y1="38" x2="42" y2="38" stroke="#555" stroke-width="2" />
                  </svg>
                  Paper & Pulp
                </p>
                <p className="mb-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <circle cx="20" cy="32" r="6" fill="#ff5512" stroke="#555" />
                    <circle cx="44" cy="32" r="6" fill="#ff5512" stroke="#555" />
                    <line x1="26" y1="32" x2="38" y2="32" stroke="#555" stroke-width="3" />
                    <circle cx="32" cy="20" r="5" fill="#bdbdbd" stroke="#555" />
                    <circle cx="32" cy="44" r="5" fill="#bdbdbd" stroke="#555" />
                    <line x1="32" y1="25" x2="32" y2="39" stroke="#555" stroke-width="3" />
                  </svg>
                  Plastics & Polymers
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
            <div className="position-relative shadow rounded border-top border-5 border-primary">
              <div className="d-flex align-items-center justify-content-center position-absolute top-0 start-50 translate-middle bg-primary rounded-circle"
                style={{ width: "45px", height: "45px", marginTop: "-3px" }}>
                <i className="fa fa-cog text-white"></i>
              </div>
              <div className="text-center border-bottom p-4 pt-5 h-200">
                <h4 className="fw-bold">Municipal & Commercial</h4>
                <p className="mb-0">Efficient water and wastewater treatment solutions for municipalities,
                  sewage systems, and infrastructure needs.</p>
              </div>
              <div className="text-center border-bottom p-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"
                  fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                  stroke-linecap="round">
                  <path d="M32 6 C24 18, 16 30, 32 54 C48 30, 40 18, 32 6 Z" fill="#ff5512"
                    stroke="#555" />
                  <rect x="6" y="36" width="12" height="22" fill="#bdbdbd" stroke="#555" />
                  <rect x="24" y="30" width="10" height="28" fill="#bdbdbd" stroke="#555" />
                  <rect x="40" y="42" width="14" height="16" fill="#bdbdbd" stroke="#555" />
                  <rect x="10" y="42" width="4" height="6" fill="#e0e0e0" stroke="#555" />
                  <rect x="28" y="38" width="3" height="6" fill="#e0e0e0" stroke="#555" />
                  <rect x="46" y="46" width="4" height="4" fill="#e0e0e0" stroke="#555" />
                </svg>
              </div>
              <div className="p-2">
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                    viewBox="0 0 64 64" fill="none" stroke="#555" stroke-width="2"
                    stroke-linejoin="round" stroke-linecap="round">
                    <rect x="14" y="16" width="36" height="24" rx="4" ry="4" fill="#ff5512"
                      stroke="#555" />
                    <path d="M14 30c4 3 8-3 12 0s8 3 12 0 8 3 12 0" stroke="#555" stroke-width="3"
                      fill="none" />
                    <line x1="14" y1="40" x2="14" y2="50" stroke="#555" stroke-width="3" />
                    <line x1="50" y1="40" x2="50" y2="50" stroke="#555" stroke-width="3" />
                    <line x1="14" y1="50" x2="50" y2="50" stroke="#555" stroke-width="3" />
                  </svg>
                  Sewage Treatment Plants
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <path d="M32 8c-8 12-12 22-12 30a12 12 0 0 0 24 0c0-8-4-18-12-30z" fill="#ff5512"
                      stroke="#555" />
                    <circle cx="32" cy="40" r="8" fill="none" stroke="#555" stroke-width="3" />
                    <line x1="32" y1="32" x2="32" y2="48" stroke="#555" stroke-width="2" />
                    <line x1="24" y1="40" x2="40" y2="40" stroke="#555" stroke-width="2" />
                    <line x1="27" y1="35" x2="37" y2="45" stroke="#555" stroke-width="2" />
                    <line x1="27" y1="45" x2="37" y2="35" stroke="#555" stroke-width="2" />
                  </svg>
                  Municipal Water Treatment
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                    viewBox="0 0 64 64" fill="none" stroke="#555" stroke-width="2"
                    stroke-linejoin="round" stroke-linecap="round">
                    <rect x="12" y="28" width="40" height="20" fill="#ff5512" stroke="#555" />
                    <rect x="18" y="22" width="8" height="10" fill="#bdbdbd" stroke="#555" />
                    <rect x="38" y="18" width="8" height="14" fill="#bdbdbd" stroke="#555" />
                    <path d="M12 48c6 3 6-3 12 0s6 3 12 0 6 3 12 0" stroke="#555" stroke-width="3"
                      fill="none" />
                  </svg>
                  Industrial Wastewater (CETPs)
                </p>
                <p className="border-bottom pb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <path d="M32 8c-8 12-12 22-12 30a12 12 0 0 0 24 0c0-8-4-18-12-30z" fill="#ff5512"
                      stroke="#555" />
                    <circle cx="32" cy="40" r="8" fill="none" stroke="#555" stroke-width="3" />
                    <line x1="32" y1="32" x2="32" y2="48" stroke="#555" stroke-width="2" />
                    <line x1="24" y1="40" x2="40" y2="40" stroke="#555" stroke-width="2" />
                    <line x1="27" y1="35" x2="37" y2="45" stroke="#555" stroke-width="2" />
                    <line x1="27" y1="45" x2="37" y2="35" stroke="#555" stroke-width="2" />
                    <rect x="10" y="44" width="10" height="10" fill="#bdbdbd" stroke="#555" />
                    <rect x="24" y="44" width="10" height="10" fill="#bdbdbd" stroke="#555" />
                    <rect x="38" y="44" width="10" height="10" fill="#bdbdbd" stroke="#555" />
                  </svg>
                  Effluent Treatment for Various Sectors
                </p>
                <p className="mb-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"
                    fill="none" stroke="#555" stroke-width="2" stroke-linejoin="round"
                    stroke-linecap="round">
                    <ellipse cx="32" cy="20" rx="18" ry="12" fill="#ff5512" stroke="#555" />
                    <path d="M24 36c0 4 4 8 8 8s8-4 8-8" stroke="#555" stroke-width="3" fill="none" />
                    <line x1="20" y1="36" x2="20" y2="44" stroke="#555" stroke-width="2" />
                    <line x1="28" y1="36" x2="28" y2="44" stroke="#555" stroke-width="2" />
                    <line x1="36" y1="36" x2="36" y2="44" stroke="#555" stroke-width="2" />
                    <line x1="44" y1="36" x2="44" y2="44" stroke="#555" stroke-width="2" />
                    <rect x="14" y="44" width="36" height="6" fill="#bdbdbd" stroke="#555" rx="2" />
                    <line x1="32" y1="44" x2="32" y2="50" stroke="#555" stroke-width="2" />
                  </svg>
                  Stormwater Management
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesWeServe;
